//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { objectCardDocuments } from './ObjectCardDocuments.js'
import FilesField from '../File/FilesField.vue'

export default {
  name: 'CardSectionDocuments',
  components: {
    FilesField
  },
  mixins: [objectCardDocuments],
  props: {
    config: {
      type: Object,
      required: true
    },
    objectSrc: {
      type: Object,
      default: null
    }
  },
  data: function () {
    const data = {
    }
    const config = this.config
    if (config.componentProps) {
      Object.assign(data, config.componentProps)
    }
    return data
  },
  watch: {
    objectSrc: {
      handler: async function (object) {
        this.onObjectChanged(object)
      },
      immediate: true
    }
  },
  created: function () {
    if (this.config.componentProps) {
      Object.entries(this.config.componentProps).forEach(entry => {
        this[entry[0]] = entry[1]
      })
    }
    this.readonly = !this.config.editable
  }
}
